"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiGetUserResponse = instanceOfApiGetUserResponse;
exports.ApiGetUserResponseFromJSON = ApiGetUserResponseFromJSON;
exports.ApiGetUserResponseFromJSONTyped = ApiGetUserResponseFromJSONTyped;
exports.ApiGetUserResponseToJSON = ApiGetUserResponseToJSON;
exports.ApiGetUserResponseToJSONTyped = ApiGetUserResponseToJSONTyped;
/**
 * Check if a given object implements the ApiGetUserResponse interface.
 */
function instanceOfApiGetUserResponse(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('userName' in value) || value['userName'] === undefined)
        return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined)
        return false;
    if (!('privilege' in value) || value['privilege'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('firstname' in value) || value['firstname'] === undefined)
        return false;
    if (!('lastname' in value) || value['lastname'] === undefined)
        return false;
    return true;
}
function ApiGetUserResponseFromJSON(json) {
    return ApiGetUserResponseFromJSONTyped(json, false);
}
function ApiGetUserResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'userName': json['user_name'],
        'tenantId': json['tenant_id'],
        'privilege': json['privilege'],
        'email': json['email'],
        'firstname': json['firstname'],
        'lastname': json['lastname'],
        'isOverrideLoginMethod': json['is_override_login_method'] == null ? undefined : json['is_override_login_method'],
        'loginMethods': json['login_methods'] == null ? undefined : json['login_methods'],
    };
}
function ApiGetUserResponseToJSON(json) {
    return ApiGetUserResponseToJSONTyped(json, false);
}
function ApiGetUserResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'user_name': value['userName'],
        'tenant_id': value['tenantId'],
        'privilege': value['privilege'],
        'email': value['email'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'is_override_login_method': value['isOverrideLoginMethod'],
        'login_methods': value['loginMethods'],
    };
}
